import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['drawer']
  connect = () => this.close()
  open = () => this.drawerTarget.classList.toggle('is-open', true)
  close = () => this.drawerTarget.classList.toggle('is-open', false)
}
